export default __webpack_public_path__ + "static/thum-video-img01-ecb82977b88895d16f2d54e2e6c8ff61.jpg";